module.exports = __webpack_public_path__ + "img/grid.3e36a97a.svg";